import {ChangeDetectionStrategy, Component, Input, OnInit} from "@angular/core";
import {EstimateQuestion, EstimateQuestionType, Order, Product, StandardName} from "../../../store/state/order.state";
import {EstimateQuestionsFormService} from "./estimate-questions-form.service";
import {FormGroup} from "@angular/forms";
import {BaseSubFormComponent} from "../../../umbrella-common/components/base-sub-form.component";

@Component({
    selector: 'estimate-questions',
    templateUrl: './estimate-questions.template.html',
    styleUrls: ['./estimate-questions.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EstimateQuestionsComponent extends BaseSubFormComponent implements OnInit {

	readonly LONG_OPTION_SINGLE_CHOICE: EstimateQuestionType = EstimateQuestionType.LONG_OPTION_SINGLE_CHOICE;

	@Input() questions: EstimateQuestion[];
	@Input() estimateQuestions: EstimateQuestion[];
	@Input() order: Order;
	@Input() product: Product;
	@Input() disabled: boolean = false;
	form: FormGroup;

	constructor(public formService: EstimateQuestionsFormService) {
		super(formService);
	}

	ngOnInit(): void {
		this.form = this.formService.buildSubForm(this.product.standard.name, this.totalSubForms(this.order), this.questions, this.product);
	}

	trackByEstimateQuestionFn(index: number, item: any) {
		return index;
	}

	getFormKey(): string {
		return this.product.standard.name;
	}

	override totalSubForms(order: Order): number {
		return order.products.filter(p => [StandardName.ISO_27001, StandardName.ISO_27701].includes(p.standard.name)).length;
	}

	protected iso27701HasItsOwnSubForm(): boolean {
		return true;
	}

}
